export default __webpack_public_path__ + "static/char-06-anr-72c90656b2197b05676c3c9fca874bbf.gif";